import React, { useEffect, useRef } from 'react';
import { useOverlay } from '@saviynt/design-system';

interface OverlayHelperProps {
  children: (zIndex: number) => React.ReactNode;
}

/** Declarative wrapper around overlay context manager. */
export default function OverlayHelper({ children }: OverlayHelperProps) {
  const { registerContentRef, unregisterContentRef } = useOverlay();
  const [zIndex, setZIndex] = React.useState<number | null>(null);
  const instanceRef = useRef({});

  useEffect(() => {
    setZIndex(registerContentRef(instanceRef));

    return () => {
      unregisterContentRef(instanceRef);
    };
  }, [registerContentRef, unregisterContentRef]);

  return zIndex === null ? null : <>{children(zIndex)}</>;
}
